import React from 'react';
import StandardPageLayout from '../components/StandardPageLayout';
import { Card, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Code, Sparkles, Zap, Palette, DollarSign, TrendingUp } from 'lucide-react';
import AppBuilderNetwork from '../components/AppBuilderNetwork';

const ProductC = () => {
  const features = [
    { icon: Code, title: 'No-Code Platform', description: 'Build apps without writing code' },
    { icon: Sparkles, title: 'AI-Powered Design', description: 'Intelligent templates and layouts' },
    { icon: Zap, title: 'Instant Deployment', description: 'Launch in minutes, not months' },
    { icon: Palette, title: 'Full Customization', description: 'Your brand, your way' },
    { icon: DollarSign, title: 'Cost-Effective', description: 'Skip the developer bill' },
    { icon: TrendingUp, title: 'Scalable Infrastructure', description: 'Grows with your business' },
  ];

  return (
    <StandardPageLayout
      customHero={<AppBuilderNetwork />}
      
      section2Title="Unlock Powerful App Building"
      section2Description="Everything you need to build, launch, and scale professional applications without developers."
      section2Content={
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <Card key={idx} className="h-full bg-[#E8E4DC] border-[#F4C2D4]/30 hover:bg-[#FDF7F9] hover:border-[#E8A0B8]/50 hover:-translate-y-1 transition-all duration-300">
              <CardHeader>
                <div className="w-12 h-12 rounded-xl bg-[#E8A0B8]/10 flex items-center justify-center mb-4">
                  <feature.icon className="w-6 h-6 text-[#E8A0B8]" />
                </div>
                <CardTitle className="text-black/90 text-lg font-sans">
                  {feature.title}
                </CardTitle>
                <CardDescription className="text-black/70 text-sm">
                  {feature.description}
                </CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      }
      
      section3Title="Built for Every Team"
      section3Description="From startups to enterprises, our platform adapts to your needs and grows with your ambitions."
      section3Content={
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {[
            {
              title: 'Startups & SMBs',
              description: 'Launch your MVP quickly without burning capital on development costs. Focus on your product, not infrastructure.',
            },
            {
              title: 'Enterprises',
              description: 'Scale confidently with enterprise-grade security, compliance, and dedicated support. Custom integrations available.',
            },
          ].map((item, idx) => (
            <Card key={idx} className="bg-white border-[#D4DDD1]/40">
              <CardHeader>
                <CardTitle className="text-xl font-medium text-black/90 mb-2">
                  {item.title}
                </CardTitle>
                <CardDescription className="text-black/70">
                  {item.description}
                </CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      }
      
      ctaTitle="Ready to build your app?"
      ctaDescription="Join thousands of teams building beautiful applications without code."
      ctaButtonText="Get started"
    />
  );
};

export default ProductC;

